<template>
  <MtxPage width="md">
    <div class="mb-5 text-center">
      <img src="/static/matryx-logo.svg" alt="Matryx Logo" class="about__logo" />
    </div>
    <div class="fluid-media">
      <iframe
        src="https://www.youtube.com/embed/4upts6wjFuY?rel=0&amp;showinfo=0"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
    <div>
      <header class="mt-5 text-center">
        <h2>Frequently Asked Questions</h2>
      </header>

      <div v-for="(category, i) in faq" :key="i" class="my-4">
        <h3 class="question__title pb-1">{{ category.title }}</h3>
        <ul class="list-plain mb-1">
          <li
            v-for="question in category.questions"
            :key="question.id"
            :id="question.id"
            :class="{ 'question--open': question.id === activeQuestionId }"
            class="py-1 px-1"
          >
            <button
              class="btn--link question__button my-2 text-left"
              @click="toggleQuestion(question.id)"
            >
              <h5 class="flex align-center question__Q color-white" tabindex="-1">
                <MtxSvg icon="icon-chevron-left" class="question__arrow mr-1 heading-6" />
                {{ question.question }}
              </h5>
            </button>
            <p
              v-if="question.id === activeQuestionId"
              class="question__A ml-1 pl-2"
              v-html="question.answer"
            ></p>
          </li>
        </ul>
      </div>
    </div>
  </MtxPage>
</template>

<script>
import FAQ from "@/data/faqs"

export default {
  data: () => ({
    faq: [],
    activeQuestionId: ""
  }),

  metaInfo: {
    titleTemplate: "%s | About",
    meta: [
      {
        name: "description",
        content:
          "Matryx is an open source platform that consists of a blockchain-based bounty system, a library of digital assets, and a marketplace."
      },
      {
        property: "og:title",
        content: "Learn About Matryx"
      }
    ]
  },

  methods: {
    toggleQuestion(questionId) {
      if (this.activeQuestionId === questionId) {
        questionId = ""
      } else {
        this.scrollToQuestion(questionId)
      }

      this.activeQuestionId = questionId
      this.setQuestionIdInUrl(questionId)
    },

    transformTitle(title) {
      return title
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^a-z0-9-]/g, "")
    },

    async scrollToQuestion(id) {
      let questionEl = document.getElementById(id)
      if (!questionEl) return
      this.activeQuestionId = id

      // Wait for active question change to update the DOM
      await this.$nextTick()

      let distance = this.getElementDistanceFromTop(questionEl)
      const windowHeight = window.innerHeight
      const questionHeight = questionEl.offsetHeight
      const headerOffset = 50
      if (windowHeight - questionHeight - headerOffset > 0) {
        distance -= (windowHeight - questionHeight) / 2
      } else {
        distance -= headerOffset
      }

      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: distance
      })
    },

    setQuestionIdInUrl(hash) {
      this.$router.push({ hash })
    },

    getElementDistanceFromTop(element) {
      let distance = 0

      while (element) {
        distance += element.offsetTop - element.scrollTop + element.clientTop
        element = element.offsetParent
      }

      return distance
    }
  },

  created() {
    this.faq = FAQ.map(category => ({
      title: category.title,
      questions: category.questions.map(q => ({
        question: q.Q,
        answer: q.A,
        id: this.transformTitle(q.Q)
      }))
    }))
  },

  mounted() {
    if (this.$route.hash) {
      const questionId = this.$route.hash.substring(1)
      this.scrollToQuestion(questionId)
    }
  }
}
</script>

<style lang="scss">
.about__logo {
  max-width: rem(400px);
}

.question {
  &__button {
    width: 100%;

    &:hover .question__Q,
    &:focus .question__Q {
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.45);
    }
  }

  &__title {
    border-bottom: 2px solid var(--highlight);
  }

  &__Q:focus {
    outline: 0;
  }

  &__arrow {
    flex-shrink: 0;
    transform: rotate(180deg);
    transition-duration: 200ms;
  }

  &--open &__arrow {
    transform: rotate(270deg);
  }

  &__A {
    border-left: 2px solid var(--highlight);
  }
}
</style>
